import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const joinWaitlist = (data) => axios.post(`${API}/waitlist`, data);
